import React, { useEffect, useState } from 'react';

// Monochrome score ring: a hairline track and a foreground arc. The number
// sits inside; no unit clutter.
const CircularProgress = ({ score, size = 96, strokeWidth = 7, className = '' }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const center = size / 2;
  const [offset, setOffset] = useState(circumference);

  useEffect(() => {
    if (score == null) { setOffset(circumference); return undefined; }
    const timer = setTimeout(() => setOffset(circumference - (score / 100) * circumference), 100);
    return () => clearTimeout(timer);
  }, [score, circumference]);

  return (
    <div className={`relative inline-grid place-items-center shrink-0 ${className}`} style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={center} cy={center} r={radius} fill="none" stroke="var(--line)" strokeWidth={strokeWidth} />
        <circle
          cx={center} cy={center} r={radius} fill="none"
          stroke="var(--fg)" strokeWidth={strokeWidth} strokeLinecap="round"
          strokeDasharray={circumference} strokeDashoffset={offset}
          className="transition-[stroke-dashoffset] duration-1000 ease-out"
        />
      </svg>
      <span className="absolute inset-0 grid place-items-center text-[1.6rem] font-medium tracking-[-0.02em] tabular-nums">
        {score != null ? Math.round(score) : '—'}
      </span>
    </div>
  );
};

export default CircularProgress;
